import React from "react"
import { useEffect, useState, useCallback } from "react"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"

import { withStyles } from 'tss-react/mui'

import { Link, Paper, Alert } from '@mui/material'

import PasswordRecoveryRequest from "./PasswordRecoveryRequest"
import PasswordRecoveryConfirm from "./PasswordRecoveryConfirm"

const useStyles = (theme, props) => ({
    paper:{
        display: 'flex' ,
        flexDirection: 'column',
        width: '400px',
        minWidth: '200px',
        maxWidth: '80vw',
        gap: theme.spacing(1),
        margin:'auto',
        marginBottom:theme.spacing(5),
        padding: theme.spacing(2.5),
        // border: '1px solid red',
    },
    mainComponentBox:{
        // border:'1px solid green'
    },
    returnButton: {
        color: 'grey',
        textDecoration: 'none',
        // border: '1px solid pink'
    },
    inputBox:{
        display:'flex',
        flexDirection:'column',
        gap:'10px',
        marginTop: theme.spacing(0.6),
        paddingTop: theme.spacing(0.6),
        // border: '1px solid purple',
    },
    alert:{
    },
    text:{
        color: "grey"
    },
    button:{
        fontWeight:"bold"
    },
})


function PasswordRecovery({classes}){

    const [state, setState] = useState({
        msg : '',
        fase : 1,
        emailOk: false,
        pathName: '',
        password:'',
        passwordConfirm: '',
    })
    const location = useLocation(); 
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token')


    useEffect(()=>{
        if (token){
            setState(old=>({...old, fase:2}))
        }
    },[token])


    const handleChildData = useCallback((data) => {
        setState({...state, ...data})
    },[state])

    return (
        <Paper className={classes.paper} elevation={24} >
        <Link href="/LoginFuncionario" className={classes.returnButton} >{"← Voltar para o login"}</Link>
        <div className={classes.mainComponentBox} >
            {state.fase === 1? <PasswordRecoveryRequest classes={classes} state={state} sendDataToParent={handleChildData}/>:null}
            {state.fase === 2? <PasswordRecoveryConfirm classes={classes} state={state} sendDataToParent={handleChildData} token={token}/> :null}
        </div>
            {state.msg !== ""? <Alert variant="outlined" severity={ state.emailOk? 'success':'error' }>{state.msg}</Alert>:null }
        </Paper>


    )
}

export default withStyles(PasswordRecovery, useStyles);